import { render, staticRenderFns } from "./GenerateHistory.vue?vue&type=template&id=723522c8&scoped=true"
import script from "./GenerateHistory.vue?vue&type=script&lang=js"
export * from "./GenerateHistory.vue?vue&type=script&lang=js"
import style0 from "./GenerateHistory.vue?vue&type=style&index=0&id=723522c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "723522c8",
  null
  
)

export default component.exports